import axios from 'axios';
import { STARCK_API } from '@config/endpoints';
import UserServiceInterface from './user-service.interface';
import UserInterface from '@redux/auth/user.interface';
import { authService } from '@dev.boon/brent';
import { Storage } from '../storage/storage';
import { reauthUser } from '@root/src/redux/auth/auth-dispatcher';
import { httpService } from '@dev.boon/brent';

class UserService implements UserServiceInterface {
    async signupUser(user: UserInterface) {
        try {
            const { data: result } = await axios.post(STARCK_API + '/user/local', {
                email: user.email,
                password: user.password,
                firstName: user.firstName,
                lastName: user.lastName,
                referralId: Storage.getItem('referralId') || '',
                re: user.re || '',
            });

            authService.setUser(result.user, result.accessToken, result.refreshToken);

            return result;
        } catch (error) {
            throw error;
        }
    }

    async signupPartner(email: string) {
        try {
            const { data: result } = await axios.post(STARCK_API + '/user/local', {
                email,
            });

            return result;
        } catch (error) {
            throw error;
        }
    }

    async changePassword(currentPassword: string, password: string) {
        try {
            const accessToken = authService.getAccessToken();
            const { data: result } = await axios({
                method: 'put',
                url: STARCK_API + '/user',
                timeout: 15000,
                data: {
                    currentPassword,
                    password,
                },
                headers: { Authorization: 'bearer ' + accessToken },
            });

            return result;
        } catch (error) {
            throw error;
        }
    }

    async forgotPassword(email: string) {
        try {
            const { data: result } = await axios({
                method: 'post',
                url: STARCK_API + '/user/forgot-password',
                timeout: 15000,
                data: {
                    email,
                },
            });

            return result;
        } catch (error) {
            throw error;
        }
    }

    async resetPassword(token: string, password: string) {
        try {
            const { data: result } = await axios({
                method: 'put',
                url: STARCK_API + '/user',
                timeout: 15000,
                data: {
                    password,
                },
                headers: { Authorization: 'bearer ' + token },
            });

            return result;
        } catch (error) {
            throw error;
        }
    }

    async updateUser(firstName: string, lastName: string) {
        try {
            const accessToken = authService.getAccessToken();
            const { data: result } = await axios({
                method: 'put',
                url: STARCK_API + '/user',
                timeout: 15000,
                data: {
                    firstName,
                    lastName,
                },
                headers: { Authorization: 'bearer ' + accessToken },
            });
            // refresh user details thru reauth
            await reauthUser();

            return result;
        } catch (error) {
            throw error;
        }
    }

    async deactivateUser(): Promise<UserInterface> {
        try {
            const { data: result } = await httpService.put({ status: 0 }, { url: STARCK_API + '/user' });
            return result;
        } catch (error) {
            throw error;
        }
    }
}

export const userService = new UserService();
